import { useLearnerPath } from '../../data/useLearnerPath';
import { ProgramsCatalogue } from '../ProgramsCatalogue';
import { DegreePrograms } from './DegreePrograms';

/**
 * Program catalogue. One url, two views: the degree catalogue for a degree
 * learner, the GSA browse/subscribe catalogue for everyone else.
 *
 * This is also the only place the catalogue is chosen: `ProgramsCatalogue`
 * reads nothing from the url, so a learner cannot ask for the other one.
 *
 * `'both'` gets the GSA catalogue and has no way to reach the degree one — see
 * `pages/Program/index.tsx` for why that is left alone (PR #1120).
 */
export const ProgramsPage = () => {
  const path = useLearnerPath();

  return path === 'degree' ? <DegreePrograms /> : <ProgramsCatalogue />;
};
